let animationsZone4 = {
    init: () => {

        // loop function for the pieChart
        function increaseSlice(selector, speed) {
            TweenMax.to(selector, speed, {
                scale: 1.1,
                opacity: 0.7,
                transformOrigin: "center",
                ease: Sine.easeOut
            });
        }


        // decrease slice
        function decreaseSlice(selector, speed, delay) {
            TweenMax.to(selector, speed, {
                scale: 1,
                opacity: 1,
                delay: delay,
                transformOrigin: "center",
                ease: Sine.easeOut
            });
        }


        /* Animate the dots
         */
        // loop function for the pieChart
        function moveDotUp(selector, speed) {
            TweenMax.to(selector, speed, {
                y: -5,
                scale: 0.8,
                opacity: 1,
                transformOrigin: "30% 50% 0",
                ease: Elastic.easeOut.config(0.7, 0.3)
            });
        }


        // decrease slice
        function moveDotDown(selector, speed, delay) {
            TweenMax.to(selector, speed, {
                y: 0,
                scale: 1,
                opacity: 1,
                delay: delay,
                transformOrigin: "30% 50% 0",
                ease: Elastic.easeOut.config(0.7, 0.3)
            });
        }


        // animate the pieChart
        var next = 1;
        setInterval(function() {

            var selector = ".slice" + next;
            increaseSlice(selector, 0.2);
            decreaseSlice(selector, 0.1, 0.2);
            // resetArrowColor(selector, 0.1);
            next++;

            if (next > 5) {
                next = 1;
            }

        }, 1000);


        // animate the dots
        var nextDot = 1;
        setInterval(function() {

            var selector = ".dot-" + nextDot;
            moveDotUp(selector, 3);
            moveDotDown(selector, 3, 1);
            // resetArrowColor(selector, 0.1);
            nextDot++;

            if (nextDot > 3) {
                nextDot = 1;
            }

        }, 1000);

    }
};

$(document).ready(animationsZone4.init);
